import React, { Component } from 'react'
import { connect } from 'react-redux'
import history from '../../../routes/history';
import * as actionCreator from '../../../redux/actions/data-action';
import connectCommon from '../../common/common-hoc';
import { assessmentStatus, termsReponse } from '../../../Constants';

import {
    AssessmentContainer,
    AssessmentContentCenteredSection,
    AssessmentBody,
    AssessmentContentHeader,
    AssessmentContent,
    AssessmentNavigationPrevious,
    AssessmentNavigationNext,
    AssessmentFooter,
    AssessmentContentError,
    AssessmentContentAction,
    AssessmentContentActionButton
} from '../../assessment/common';

const backLink = "/TermsAndConditions";
const nextLink = "/FinalTermination";

class TermsDeclineScreenEnglish extends Component {
    constructor(props) {
        super(props);

        this.state = { errorMessage: '' };

        this.handleBack = this.handleBack.bind(this);
        this.handleNext = this.handleNext.bind(this);
    }

    handleBack() {
        const { setTerms, setAssessmentStatus } = this.props;
        setAssessmentStatus(assessmentStatus.InProgress);
        history.push(backLink);
    }

    handleNext() {
        this.setState({ errorMessage: 'Please provide a response' });
    }

    render() {
        return (
            <AssessmentContainer>
                <AssessmentContentHeader></AssessmentContentHeader>
                <AssessmentBody>
                    <AssessmentContent>
                        <AssessmentContentCenteredSection>
                            You have declined to complete Conners 4. For more information, please contact your Conners 4 administrator.
                        </AssessmentContentCenteredSection>
                        <AssessmentContentCenteredSection>
                            If you would like to complete Conners 4, please return to the legal information page and click “I Accept” to continue.
                        </AssessmentContentCenteredSection>
                        <AssessmentContentError>
                            {this.state.errorMessage}
                        </AssessmentContentError>
                        <AssessmentContentAction>
                            <AssessmentContentActionButton styleType='arrows' onClick={this.handleBack}>{'<'}</AssessmentContentActionButton>
                            {/* <AssessmentContentActionButton onClick={this.handleExit}>Close</AssessmentContentActionButton> */}
                        </AssessmentContentAction>
                    </AssessmentContent>
                </AssessmentBody>
                <AssessmentFooter includeProgress={false} includeLogo={true}></AssessmentFooter>
            </AssessmentContainer>
        )
    }
}

export default connect(null, actionCreator)(connectCommon(TermsDeclineScreenEnglish));